import React, { useState, useEffect } from "react";
import Sidebar from "../../dashboard/sidebar";
import Navbar from "../../dashboard/navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import useAuth from "../../dashboard/useAuth";
import { FaChevronRight, FaSortAmountUp, FaSortAmountDown, FaChartLine, FaFileDownload, FaBook, FaFolderOpen, FaCheck, FaCheckCircle, FaRedo, FaFlagCheckered, FaTasks, FaQuestionCircle, FaInfoCircle, FaStar } from "react-icons/fa";
import { Dropdown } from 'react-bootstrap';

import {
  Chart as ChartJS,
  CategoryScale, // Nécessaire pour les axes de type "category"
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from "axios";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


const Parcours = () => {
  useAuth(); // Vérifier l'authentification
  const location = useLocation();
  const navigate = useNavigate();
  const { user, titre } = location.state || {};
  const user_id = localStorage.getItem("user_id");
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
  const [parcours, setParcours] = useState([]);
  const [ressource, setRessource] = useState();
  const [progress, setProgress] = useState(0);
  const [openSemaine, setOpenSemaine] = useState({}); // État pour gérer les semaines ouvertes/fermées
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGlobale, setIsLoadingGlobale] = useState(false);

  const [evaluation, setEvaluation] = useState({
    domaine: '',
    processus: '',
    niveau: '',
    tags: '',
    agile: false,
    nonTraite: false,
  });

  const [parcoursListe, setParcoursListe] = useState([]);
  const fetchParcoursListe = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + '/liste-parcours/');
      const data = await response.json();
      if (response.ok) {
        setParcoursListe(data.parcours);
      } else {
        console.error('Erreur lors de la récupération des parcours : ', data);
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };
  useEffect(() => {
    fetchParcoursListe();
  }, []);

  const fetchParcours = async () => {
    setIsLoadingGlobale(true)
    try {
      const response = await fetch(
        process.env.REACT_APP_HOTE + `/recuperer-etapes-par-utilisateur/${user_id}/`
      );
      if (response.ok) {
        const data = await response.json();
        const etapes = Object.values(data.fichiers_data).flatMap(
          (file) => file.etapes || []
        );
        setParcours(etapes);
        const ressource = Object.values(data.fichiers_data).flatMap(
          (file) => file.ressource || []
        );
        setRessource(ressource)

        // Calcul de la progression
        const termineCount = etapes.filter(
          (etape) => etape.statut_etape === "Terminée"
        ).length;
        const totalCount = etapes.length;
        setProgress(totalCount > 0 ? Math.round((termineCount / totalCount) * 100) : 0);
        setIsLoadingGlobale(false)
      } else {
        const errorData = await response.json();
        console.error("Erreur lors de la récupération des parcours:", errorData);
        setIsLoadingGlobale(false)
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
      setIsLoadingGlobale(false)
    }
  };

  const handleDownloadRessource = (parcour_id) => {

    // Construire l'URL pour le téléchargement
    const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger-ressource/${parcour_id}/${user_id}/`;
    //window.location.href = downloadUrl;

    // Utiliser `fetch` pour vérifier si l'URL est valide
    fetch(downloadUrl, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          // Si le fichier existe, redirige l'utilisateur pour lancer le téléchargement
          window.location.href = downloadUrl;
          showAlert("Téléchargement éffectué.");
        } else {
          showAlert("Le fichier est introuvable ou le téléchargement a échoué.");
        }
      })
      .catch((error) => {
        console.error("Erreur lors du téléchargement :", error);
        showAlert("Une erreur s'est produite lors du téléchargement.");
      });
  };



  // useEffect(() => {
  //   // Vérifier si c'est la première visite
  //   const hasVisited = localStorage.getItem("hasVisitedDashboard");
  //   if (!hasVisited) {
  //     localStorage.setItem("hasVisitedDashboard", "true");
  //     window.location.reload();
  //   }
  // }, [user_id]);

  const showAlert = (message, type = 'success') => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: '', type: '' });
    }, 5000);
  };

  useEffect(() => {
    fetchParcours();
  }, [user_id]);

  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Parcours d'apprentissage"; // Définit le titre de la page
    }
  }, [user_id]);

  const groupByParcoursId = (parcours) => {
    return parcours.reduce((acc, etape) => {
      const parcoursId = etape.parcours_id || 'Parcours inconnu'; // Utilisez un nom par défaut pour les étapes sans `parcours_id`
      if (!acc[parcoursId]) {
        acc[parcoursId] = [];
      }
      acc[parcoursId].push(etape);
      return acc;
    }, {});
  };

  const groupedParcours = groupByParcoursId(parcours);


  // Fonction pour générer les données du graphique pour un parcours donné
  const getParcoursChartData = (parcours) => {
    if (!parcours || parcours.length === 0) return null;

    return {
      labels: parcours.map((_, index) => `Étape ${index + 1}`), // Génère Étape 1, Étape 2, etc.
      datasets: [
        {
          label: "Progression des étapes",
          data: parcours.map((etape) =>
            etape.statut_etape === "Terminée" ? 100 : 0
          ), // 100% si terminé, sinon 0%
          backgroundColor: parcours.map((etape) =>
            etape.statut_etape === "Terminée" ? "rgba(75, 192, 192, 0.6)" : "rgba(255, 99, 132, 0.6)"
          ),
          borderWidth: 1,
        },
      ],
    };
  };

  // Options du graphique
  const chartOptions = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: "Étapes",
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "Progression (%)",
        },
      },
    },
  };

  // Fonction pour récupérer le dernier parcours
  const getLastParcours = (groupedParcours) => {
    const lastParcoursId = Object.keys(groupedParcours).pop();
    return groupedParcours[lastParcoursId] || [];
  };

  // Fonction pour vérifier si l'étape précédente est terminée
  const isPreviousStepCompleted = (etape, parcoursData) => {
    if (!etape.etapePrec || etape.etapePrec === 0) {
      return true;
    }

    // Trouver l'étape précédente dans toutes les étapes du parcours
    const previousEtape = parcoursData.find(e => e.id === etape.etapePrec);

    // Si l'étape précédente existe et est terminée
    return previousEtape && previousEtape.statut_etape === "Terminée";
  };


  const handleEtapeClick = async (etape) => {
    const etapeId = etape.id;
    const module = etape.module;
    setIsLoading(true);

    try {
      const excludedModules = ["Revision", "Evaluation", "Eligibilite"];

      if (excludedModules.includes(module)) {
        if (module === "Revision") {
          // Appel pour terminer l'étape
          const terminerEtapeResponse = await fetch(
            `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etapeId}/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!terminerEtapeResponse.ok) {
            // throw new Error("Erreur lors de la tentative de terminer l'étape");
            const data = await terminerEtapeResponse.json();
            setIsLoading(false);
          }

          const terminerData = await terminerEtapeResponse.json();
          setIsLoading(false);
          fetchParcours();

        } else if (module === "Eligibilite") {
          const terminerEtapeResponse = await fetch(
            `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etapeId}/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!terminerEtapeResponse.ok) {
            // throw new Error("Erreur lors de la tentative de terminer l'étape");
            const data = await terminerEtapeResponse.json();
            setIsLoading(false);
          }

          const terminerData = await terminerEtapeResponse.json();
          setIsLoading(false);
          fetchParcours();
          navigate(`/eligibilite`);

        } else if (module === "Etude_de_cas") {
          const terminerEtapeResponse = await fetch(
            `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etapeId}/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!terminerEtapeResponse.ok) {
            // throw new Error("Erreur lors de la tentative de terminer l'étape");
            const data = await terminerEtapeResponse.json();
            setIsLoading(false);
          }

          const terminerData = await terminerEtapeResponse.json();
          setIsLoading(false);
          fetchParcours();
          navigate(`/Etude-de-cas`);

        } else {
          try {
            const evaluationData = {
              ...evaluation,
              tags: `${evaluation.tags ? evaluation.tags + ", " : ""}${etape.tags}`,
              nombre_qcm: etape.nombre_qcm,
            };

            const response = await fetch(
              `${process.env.REACT_APP_HOTE}/enreg-evaluation/${user_id}/`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(evaluationData),
              }
            );
            const data = await response.json();

            if (!response.ok) {
              console.log("Erreur lors de l'enregistrement de l'évaluation", data);
              setIsLoading(false);
            }

            console.log("Réponse du serveur (évaluation enregistrée) :", data);

            // Démarrer l'évaluation
            const demarrerResponse = await fetch(
              `${process.env.REACT_APP_HOTE}/demarrer-evaluation/${user_id}/${data.evaluation_id}/`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            const demarrerData = await demarrerResponse.json();
            console.log("Réponse du serveur (démarrer évaluation) :", demarrerData);

            if (!demarrerResponse.ok) {
              showAlert(demarrerData.error, 'danger');
            } else {
              navigate(`/demarrer-qcm`, {
                state: { evaluation_id: data.evaluation_id, etape_id: etapeId, tag: etape.tags },
              });
            }
          } catch (error) {
            console.error("Erreur:", error);
          } finally {
            setIsLoading(false);
          }
        }
      } else {
        console.log(`Aucune action requise pour le module : ${module}`);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erreur:", error);
      showAlert("Une erreur est survenue lors de la tentative de terminer l'étape !");
      setIsLoading(false);
    }
  };

  const handleDownload = (etapeId) => {
    if (!etapeId) {
      showAlert("Aucun fichier à télécharger.");
      return;
    }

    // Construire l'URL pour le téléchargement
    const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger_fichier/${etapeId}/${user_id}/`;
    //window.location.href = downloadUrl;

    // Utiliser `fetch` pour vérifier si l'URL est valide
    fetch(downloadUrl, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          // Si le fichier existe, redirige l'utilisateur pour lancer le téléchargement
          window.location.href = downloadUrl;
        } else {
          showAlert("Le fichier est introuvable ou le téléchargement a échoué.");
        }
      })
      .catch((error) => {
        console.error("Erreur lors du téléchargement :", error);
        showAlert("Une erreur s'est produite lors du téléchargement.");
      });
  };



  const handleHistorique = (etape_id, parcours_id) => {
    if (etape_id) {
      navigate(`/Historique-evaluation`, {
        state: { etape_id: etape_id, parcours_id: parcours_id },
      });
    }
  };


  const [etapeStatuses, setEtapeStatuses] = useState([]);
  const [etapes, setEtapes] = useState([]);

  useEffect(() => {
    // Vérifie le statut et l'échéance de chaque étape
    const updatedStatuses = etapes.map((etape) => {
      const isLate =
        etape.statut_etape !== "Terminée" &&
        new Date(etape.date_echeance) < new Date();

      return {
        ...etape,
        isLate,
      };
    });
    setEtapeStatuses(updatedStatuses);
  }, [etapes]);








  const [openParcoursId, setOpenParcoursId] = useState(null); // Suivre l'ID du parcours ouvert

  const handleToggle = (selectedParcours) => {
    // Si l'ID du parcours est déjà ouvert, le fermer, sinon l'ouvrir
    setOpenParcoursId(openParcoursId === selectedParcours ? null : selectedParcours);
  };



  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;  // Nombre d'éléments par page

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // Filtrer les données selon la recherche
  const filteredData = (parcoursId) => {
    const currentData = groupedParcours[parcoursId];
    return currentData.filter((etape) => {
      return (
        etape.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.module.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.date_echeance.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.numero.toString().includes(searchTerm.toLowerCase()) ||
        etape.score.toString().includes(searchTerm.toLowerCase()) ||
        etape.statut_etape.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  };

  // Calculer les indices de début et de fin de la page actuelle
  const getCurrentPageData = (parcoursId) => {
    const filteredPageData = filteredData(parcoursId);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredPageData.slice(startIndex, endIndex);
  };

  // Changer de page
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getTextColor = (bgColor) => {
    if (!bgColor || bgColor === 'transparent') return 'inherit'; // Couleur par défaut

    // Convertit la couleur hex en RGB
    const hexToRgb = (hex) => {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : [0, 0, 0];
    };

    const [r, g, b] = hexToRgb(bgColor);

    // Calcule la luminance (formule de perception humaine)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Retourne noir ou blanc selon la luminance
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  };



  const getModuleIcon = (module) => {
    switch (module) {
      case 'Cours':
        return <FaBook className="mr-2" />;
      case 'Ressources':
        return <FaFolderOpen className="mr-2" />;
      case 'Evaluation':
        return <FaQuestionCircle className="mr-2" />;
      case 'Revision':
        return <FaRedo className="mr-2" />;
      case 'Eligibilite':
        return <FaFlagCheckered className="mr-2" />;
      case 'Avis_client':
        return <FaStar className="mr-2" />;
      default:
        return <FaTasks className="mr-2" />;
    }
  };


  const getModuleName = (module) => {
    switch (module) {
      case 'Cours':
        return "Cours";
      case 'Ressources':
        return "Ressources";
      case 'Evaluation':
        return "Evaluation";
      case 'Revision':
        return "Revision";
      case 'Eligibilite':
        return "Eligibilite";
      case 'Avis_client':
        return "Avis client";
      case 'Etude_de_cas':
        return "Etude de cas";
      default:
        return <FaTasks className="mr-2" />;
    }
  };






  // const [accesGroupe, setAccesGroupe] = useState([]);
  // const [groupeId, setGroupeId] = useState(null);
  // const groupe = localStorage.getItem('groupe');

  // const verifGroupe = async () => {
  //   const groupeStored = localStorage.getItem('groupe');
  //   const accesGroupeStored = localStorage.getItem('accesGroupe');

  //   if (groupeStored && accesGroupeStored) {
  //     setGroupeId(groupeStored);
  //     setAccesGroupe(JSON.parse(accesGroupeStored));
  //   } else {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
  //       if (response.status === 200) {
  //         const data = response.data;
  //         setGroupeId(data.groupe);

  //         let cleanedAccessArray = [];
  //         if (Array.isArray(data.acces)) {
  //           cleanedAccessArray = data.acces.map((item) =>
  //             item.acces
  //               ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
  //               : []
  //           ).flat();

  //           setAccesGroupe(cleanedAccessArray);
  //         }

  //         localStorage.setItem('groupe', data.groupe);
  //         localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
  //       }
  //     } catch (error) {
  //       // console.error('Erreur lors de la vérification du groupe', error);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (user_id) {
  //     verifGroupe();
  //   }
  // }, [user_id]);

  // if (!accesGroupe.includes("Apprentisage")) {
  //   return null;
  // }

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-12">
            <h2 className="d-flex align-items-center">
              <FaChartLine size={25} className="mr-2" />
              Parcours d'Apprentissage
            </h2>
            <small>Aperçu du Parcours.</small>

            <small id="hbreadcrumb" className="d-flex justify-content-end">
              <ol className="breadcrumb custom-breadcrumb">
                <li className="breadcrumb-item custom-breadcrumb-item">
                  <Link to={`/parcours`}>Parcours</Link>
                </li>
              </ol>
            </small>
          </div>
        </div>


        {alert.message && (
          <div className={`alert alert-${alert.type}`}>
            {alert.message}
          </div>
        )}
        <div className="mt-4">

          <div className="row wrapper wrapper-content animated fadeInRight">
            <div className="col-lg-12">
              {!isLoadingGlobale ? (
                <div className="mb-5 mt-0">
                  {Object.keys(groupedParcours).length > 0 ? (
                    Object.keys(groupedParcours).length === 1 ? (
                      <div className="ibox-content col-md-12">
                        {Object.keys(groupedParcours).map((parcoursId) => {
                          const parcoursTitre = groupedParcours[parcoursId][0].parcours_titre;
                          const currentPageData = getCurrentPageData(parcoursId);
                          const filteredPageData = filteredData(parcoursId);
                          const totalItems = filteredPageData.length;
                          const totalPages = Math.ceil(totalItems / itemsPerPage);
                          const parcoursEtapes = groupedParcours[parcoursId];
                          const completedSteps = parcoursEtapes.filter((etape) => etape.statut_etape === "Terminée").length;
                          const totalSteps = parcoursEtapes.length;
                          const progress = Math.round((completedSteps / totalSteps) * 100);

                          return (
                            <React.Fragment key={parcoursId}>
                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                  <div className="d-flex align-items-center mb-2 mb-md-0">
                                    <h5 className="text-dark mr-3 mb-0">{parcoursTitre}</h5>

                                    <div className="d-flex align-items-center">
                                      <h1 className="no-margins mr-2">{completedSteps} / {totalSteps}</h1>
                                      <p className="mb-0">Etapes</p>
                                    </div>

                                    {parcoursListe && parcoursListe.length > 0 && (
                                      (() => {
                                        const parcours = parcoursListe.find(p => p.id === Number(parcoursId));
                                        if (parcours && parcours.ressource != null) {
                                          return (
                                            <button
                                              onClick={() => handleDownloadRessource(parcoursId)}
                                              className="btn btn-success btn-sm ml-2"
                                            >
                                              Ressources <FaFileDownload size={14} />
                                            </button>
                                          );
                                        }
                                        return null;
                                      })()
                                    )}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Rechercher..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                  />
                                </div>
                              </div>
                              <div className="custom-table-container">
                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                  <thead>
                                    <tr className="text-center">
                                      <th className="text-secondary text-wrap d-none d-md-table-cell text-left">#</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('titre')}>Tâches {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('module')}>Description {sortConfig.key === 'module'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('date_echeance')}>Échéance {sortConfig.key === 'date_echeance'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('score')}>Score {sortConfig.key === 'score'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('statut_etape')}>Avancement {sortConfig.key === 'statut_etape'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('nbre_heure')}>Action {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredPageData.map((etape, index) => {
                                      const isFirstStep = (index === 0) ||
                                        etape.module === "Ressources" ||
                                        (etape.module === "Cours" && etape.statut_etape === "Terminée");

                                      // Vérifier si l'étape précédente est terminée en utilisant toutes les données
                                      const isPreviousCompleted = isPreviousStepCompleted(etape, filteredPageData);

                                      // Désactiver l'étape si elle n'est pas première ET que l'étape précédente n'est pas terminée
                                      const isDisabled = !isFirstStep && !isPreviousCompleted;

                                      const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                      const now = new Date();
                                      const isEcheanceDepassee = dateEcheance < now;

                                      return (
                                        <tr key={etape.id}
                                          className="text-center"
                                          style={{
                                            backgroundColor: etape.code_couleur || 'transparent',
                                            color: getTextColor(etape.code_couleur),
                                            opacity: isDisabled ? 0.5 : 1
                                          }}
                                        >
                                          <td className="text-left">{etape.numero}</td>
                                          <td className="text-left d-flex align-items-center">
                                            {getModuleIcon(etape.module)}
                                            {etape.titre}
                                          </td>

                                          <td className="d-none d-md-table-cell">{getModuleName(etape.module)}</td>
                                          <td>
                                            {(() => {
                                              const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                              const now = new Date();
                                              const isEcheanceDepassee = dateEcheance < now;
                                              const pasTerminee = etape.statut_etape !== "Terminée";

                                              if (pasTerminee) {
                                                // Si pas terminée, on colore selon échéance
                                                return isEcheanceDepassee
                                                  ? <span className="badge badge-danger">{etape.date_echeance}</span>
                                                  : <span>{etape.date_echeance}</span>;
                                              } else {
                                                // Si terminée, on affiche sans badge, couleur neutre
                                                return <span>{etape.date_echeance}</span>;
                                              }
                                            })()}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {etape.score
                                              ? `${etape.score} (${etape.pourcentage_evaluation}%)`
                                              : ''}
                                            {/* {etape.score
                                            ? (<button title="Historique" onClick={() => handleHistorique(etape.id, etape.parcours_id)} className="btn btn-success pl-1 pr-1 pt-0 pb-0 ml-2"> <FaRegNewspaper /> </button>)
                                            : ''} */}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            <span className="badge badge-primary">
                                              {etape.statut_etape === "Terminée" && <FaCheck />}
                                            </span>
                                          </td>
                                          <td>
                                            {((etape.module === "Evaluation" || etape.module === "Revision" || etape.module === "Eligibilite" || etape.module === "Avis_client") &&
                                              (etape.module !== "Revision" || etape.statut_etape !== "Terminée")) ||
                                              (etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée") ||
                                              (etape.module === "Ressources" && etape.fichier) ||
                                              etape.score ||
                                              etape.lien_url ? (
                                              <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic" className="p-0 pr-1 pl-1">
                                                  <i className="fa fa-ellipsis-v text-dark"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="p-1">
                                                  {/* Option pour Eligibilite */}
                                                  {etape.module === "Eligibilite" && (
                                                    <Dropdown.Item
                                                      onClick={() => handleEtapeClick(etape)}
                                                      disabled={isDisabled}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <i className="fa fa-flag-checkered mr-2" />
                                                      Terminer
                                                    </Dropdown.Item>
                                                  )}

                                                  {/* Options pour Evaluation et Revision */}
                                                  {(etape.module === "Evaluation" || etape.module === "Revision") &&
                                                    (etape.module !== "Revision" || etape.statut_etape !== "Terminée") && (
                                                      <Dropdown.Item
                                                        onClick={() => handleEtapeClick(etape)}
                                                        disabled={isDisabled}
                                                        className="d-flex align-items-center"
                                                      >
                                                        {etape.module === "Revision" ? (
                                                          <>
                                                            <i className="fa fa-flag-checkered mr-2" />
                                                            Terminer
                                                          </>
                                                        ) : etape.statut_etape === "Terminée" ? (
                                                          <>
                                                            <i className="fa fa-undo mr-2" />
                                                            Reprendre
                                                          </>
                                                        ) : (
                                                          <>
                                                            <i className="fa fa-question-circle mr-2" />
                                                            Lancer qcm
                                                          </>
                                                        )}
                                                      </Dropdown.Item>
                                                    )}

                                                  {/* Autres options (uniquement si ce n'est pas une Eligibilite) */}
                                                  {etape.module !== "Eligibilite" && (
                                                    <>
                                                      {etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée" && (
                                                        <Dropdown.Item
                                                          onClick={() => handleDownload(etape.id)}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-download mr-2"></i>
                                                          Télécharger
                                                        </Dropdown.Item>
                                                      )}

                                                      {etape.score && (
                                                        <Dropdown.Item
                                                          onClick={() => handleHistorique(etape.id, etape.parcours_id)}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-history mr-2"></i>
                                                          Historique
                                                        </Dropdown.Item>
                                                      )}

                                                      {etape.lien_url && (
                                                        <Dropdown.Item
                                                          onClick={() => window.open(etape.lien_url, '_blank')}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-play-circle mr-2"></i>
                                                          Voir vidéo
                                                        </Dropdown.Item>
                                                      )}

                                                      {etape.module === "Avis_client" && (
                                                        <Dropdown.Item
                                                          onClick={() => navigate(`/Formulaire-avis-client`, {
                                                            state: { etapeId: etape.id }
                                                          })}
                                                          disabled={isDisabled}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-star mr-2" />
                                                          Lancer avis
                                                        </Dropdown.Item>
                                                      )}
                                                    </>
                                                  )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            ) : null}
                                          </td>
                                        </tr>
                                      );
                                    })}

                                  </tbody>
                                </table>
                              </div>

                              {/* Pagination Controls */}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    ) : (
                      // Affichage des deux tableaux si plusieurs parcours
                      <div className="d-flex flex-column flex-md-row">
                        {/* Section gauche : Tableau des parcours */}
                        <div className="ibox-content col-md-3 order-1 order-md-1 mr-md-2">
                          <table
                            className="footable table table-stripped footable-loaded tablet breakpoint"
                            data-page-size="8"
                            data-filter="#filter"
                          >
                            <thead>
                              <tr className="d-flex justify-content-between">
                                <th>Parcours</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(groupedParcours)
                                .sort((a, b) => b - a)
                                .map((parcoursId, index) => {
                                  const isDefaultOpen = index === 0;
                                  const parcoursTitre = groupedParcours[parcoursId][0].parcours_titre;

                                  if (isDefaultOpen && openParcoursId === null) {
                                    setTimeout(() => handleToggle(parcoursId), 0);
                                  }

                                  return (
                                    <React.Fragment key={parcoursId}>
                                      <tr
                                        className={`cursor-pointer ${openParcoursId === parcoursId
                                          ? 'text-white bg-success'
                                          : 'text-dark'
                                          }`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleToggle(parcoursId)}
                                      >
                                        <td className="d-flex justify-content-between">
                                          {parcoursTitre}
                                          {openParcoursId === parcoursId && (
                                            <FaChevronRight className="ml-2" />
                                          )}
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>

                        {/* Section droite : Détails */}
                        <div className="ibox-content col-md-9 order-2 order-md-2">
                          {Object.keys(groupedParcours).length > 0 ? (
                            <div>
                              {Object.keys(groupedParcours).map((parcoursId) => {
                                const parcoursTitre = groupedParcours[parcoursId][0].parcours_titre;
                                const currentPageData = getCurrentPageData(parcoursId);
                                const filteredPageData = filteredData(parcoursId);
                                const totalItems = filteredPageData.length;
                                const totalPages = Math.ceil(totalItems / itemsPerPage);
                                const parcoursEtapes = groupedParcours[parcoursId];
                                const completedSteps = parcoursEtapes.filter(
                                  (etape) => etape.statut_etape === 'Terminée'
                                ).length;
                                const totalSteps = parcoursEtapes.length;

                                return (
                                  <React.Fragment key={parcoursId}>
                                    {openParcoursId === parcoursId && (
                                      <div>
                                        {/* Section de titre et recherche */}
                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                                          {/* Titre et étapes */}
                                          <div className="d-flex align-items-center mb-2 mb-md-0">


                                            {
                                              parcoursListe && parcoursListe.length > 0 && (
                                                // Cherche le parcours correspondant
                                                (() => {
                                                  const parcours = parcoursListe.find(p => p.id === Number(parcoursId));
                                                  // Vérification si le parcours existe et possède une ressource non vide
                                                  if (parcours && parcours.ressource != null) {
                                                    return (
                                                      <button onClick={() => handleDownloadRessource(parcoursId)} className="btn btn-success mt-2 mr-2 col-auto p-1">
                                                        Ressources <FaFileDownload />
                                                      </button>
                                                    );
                                                  } else {
                                                    return null;
                                                  }
                                                })()
                                              )
                                            }

                                            <div className="d-flex align-items-center">
                                              <h1 className="no-margins mr-2">
                                                {completedSteps} / {totalSteps}
                                              </h1>
                                              <p className="mt-2">Étapes</p>
                                            </div>
                                          </div>
                                          {/* Barre de recherche */}
                                          <div className="w-30">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Rechercher..."
                                              value={searchTerm}
                                              onChange={handleSearchChange}
                                            />
                                          </div>
                                        </div>

                                        {/* Table des étapes */}
                                        <div className="custom-table-container">
                                          <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                          >
                                            <thead>
                                              <tr className="text-center">
                                                <th className="text-secondary text-wrap d-none d-md-table-cell text-left">#</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('titre')}>Tâches {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('module')}>Description {sortConfig.key === 'module'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('date_echeance')}>Échéance {sortConfig.key === 'date_echeance'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('score')}>Score {sortConfig.key === 'score'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('statut_etape')}>Avancement {sortConfig.key === 'statut_etape'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('nbre_heure')}>Action {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {filteredPageData.map((etape, index) => {
                                                const isFirstStep = (index === 0) ||
                                                  etape.module === "Ressources" ||
                                                  (etape.module === "Cours" && etape.statut_etape === "Terminée");

                                                // Vérifier si l'étape précédente est terminée en utilisant toutes les données
                                                const isPreviousCompleted = isPreviousStepCompleted(etape, filteredPageData);

                                                // Désactiver l'étape si elle n'est pas première ET que l'étape précédente n'est pas terminée
                                                const isDisabled = !isFirstStep && !isPreviousCompleted;

                                                const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                                const now = new Date();
                                                const isEcheanceDepassee = dateEcheance < now;


                                                return (
                                                  <tr
                                                    key={etape.id}
                                                    className="text-center"
                                                    style={{
                                                      backgroundColor: etape.code_couleur || 'transparent',
                                                      color: getTextColor(etape.code_couleur),
                                                      opacity: isDisabled ? 0.5 : 1
                                                    }}
                                                  >
                                                    <td className="text-left">{etape.numero}</td>
                                                    <td className="text-left d-flex align-items-center">
                                                      {getModuleIcon(etape.module)}
                                                      {etape.titre}
                                                    </td>

                                                    <td className="text-left">{getModuleName(etape.module)}</td>
                                                    <td>
                                                      {(() => {
                                                        const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                                        const now = new Date();
                                                        const isEcheanceDepassee = dateEcheance < now;
                                                        const pasTerminee = etape.statut_etape !== "Terminée";

                                                        if (pasTerminee) {
                                                          // Si pas terminée, on colore selon échéance
                                                          return isEcheanceDepassee
                                                            ? <span className="badge badge-danger">{etape.date_echeance}</span>
                                                            : <span>{etape.date_echeance}</span>;
                                                        } else {
                                                          // Si terminée, on affiche sans badge, couleur neutre
                                                          return <span>{etape.date_echeance}</span>;
                                                        }
                                                      })()}
                                                    </td>

                                                    <td>
                                                      {etape.score
                                                        ? `${etape.score} (${etape.pourcentage_evaluation}%)`
                                                        : ''}
                                                      {/* {etape.score
                                                        ? (<button title="Historique" onClick={() => handleHistorique(etape.id, etape.parcours_id)} className="btn btn-success pl-1 pr-1 pt-0 pb-0 ml-2"> <FaRegNewspaper /> </button>)
                                                        : ''} */}
                                                    </td>

                                                    <td>
                                                      <span className="badge badge-primary">
                                                        {etape.statut_etape === "Terminée" && <FaCheck />}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      {((etape.module === "Evaluation" || etape.module === "Revision" || etape.module === "Eligibilite" || etape.module === "Avis_client") &&
                                                        (etape.module !== "Revision" || etape.statut_etape !== "Terminée")) ||
                                                        (etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée") ||
                                                        (etape.module === "Ressources" && etape.fichier) ||
                                                        etape.score ||
                                                        etape.lien_url ? (
                                                        <Dropdown>
                                                          <Dropdown.Toggle variant="light" id="dropdown-basic" className="p-0 pr-1 pl-1">
                                                            <i className="fa fa-ellipsis-v text-dark"></i>
                                                          </Dropdown.Toggle>

                                                          <Dropdown.Menu className="p-1">
                                                            {/* Option pour Eligibilite */}
                                                            {etape.module === "Eligibilite" && (
                                                              <Dropdown.Item
                                                                onClick={() => handleEtapeClick(etape)}
                                                                disabled={isDisabled}
                                                                className="d-flex align-items-center"
                                                              >
                                                                <i className="fa fa-flag-checkered mr-2" />
                                                                Terminer
                                                              </Dropdown.Item>
                                                            )}

                                                            {/* Options pour Evaluation et Revision */}
                                                            {(etape.module === "Evaluation" || etape.module === "Revision") &&
                                                              (etape.module !== "Revision" || etape.statut_etape !== "Terminée") && (
                                                                <Dropdown.Item
                                                                  onClick={() => handleEtapeClick(etape)}
                                                                  disabled={isDisabled}
                                                                  className="d-flex align-items-center"
                                                                >
                                                                  {etape.module === "Revision" ? (
                                                                    <>
                                                                      <i className="fa fa-flag-checkered mr-2" />
                                                                      Terminer
                                                                    </>
                                                                  ) : etape.statut_etape === "Terminée" ? (
                                                                    <>
                                                                      <i className="fa fa-undo mr-2" />
                                                                      Reprendre
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      <i className="fa fa-question-circle mr-2" />
                                                                      Lancer qcm
                                                                    </>
                                                                  )}
                                                                </Dropdown.Item>
                                                              )}

                                                            {/* Autres options (uniquement si ce n'est pas une Eligibilite) */}
                                                            {etape.module !== "Eligibilite" && (
                                                              <>
                                                                {etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée" && (
                                                                  <Dropdown.Item
                                                                    onClick={() => handleDownload(etape.id)}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-download mr-2"></i>
                                                                    Télécharger
                                                                  </Dropdown.Item>
                                                                )}

                                                                {etape.score && (
                                                                  <Dropdown.Item
                                                                    onClick={() => handleHistorique(etape.id, etape.parcours_id)}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-history mr-2"></i>
                                                                    Historique
                                                                  </Dropdown.Item>
                                                                )}

                                                                {etape.lien_url && (
                                                                  <Dropdown.Item
                                                                    onClick={() => window.open(etape.lien_url, '_blank')}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-play-circle mr-2"></i>
                                                                    Voir vidéo
                                                                  </Dropdown.Item>
                                                                )}

                                                                {etape.module === "Avis_client" && (
                                                                  <Dropdown.Item
                                                                    onClick={() => navigate(`/Formulaire-avis-client`, {
                                                                      state: { etapeId: etape.id }
                                                                    })}
                                                                    disabled={isDisabled}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-star mr-2" />
                                                                    Lancer avis
                                                                  </Dropdown.Item>
                                                                )}
                                                              </>
                                                            )}
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      ) : null}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>

                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-center">
                              <p>Aucun parcours trouvé.</p>
                            </div>
                          )}
                        </div>
                      </div>

                    )
                  ) : (
                    <div className="text-center">
                      <div className="ibox-content p-5" style={{
                        borderRadius: "15px",
                        backgroundColor: "#f8f9fa",
                        border: "2px dashed #dee2e6"
                      }}>
                        <div className="mb-4">
                          <FaChartLine size={80} className="text-muted mb-3" />
                          <h3 className="text-muted mb-3">Aucun parcours disponible</h3>
                          <p className="text-muted mb-4">
                            Vous n'avez actuellement aucun parcours d'apprentissage assigné.
                          </p>
                        </div>

                        <div className="row justify-content-center">
                          <div className="col-md-8">

                            <div className="d-flex justify-content-center gap-3 flex-wrap">
                              <button
                                className="btn btn-primary mr-2"
                                onClick={() => window.location.reload()}
                              >
                                <FaRedo className="mr-2" />
                                Actualiser la page
                              </button>
                              <button
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                  const message = encodeURIComponent("Bonjour, je souhaite obtenir des informations sur les parcours d'apprentissage.");
                                  window.open(`https://wa.me/22958585050?text=${message}`, '_blank');
                                }}
                              >
                                <FaBook className="mr-2" />
                                Contacter le support
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="spiner-example">
                    <div className="sk-spinner sk-spinner-wave">
                      <div className="sk-rect1 mr-1"></div>
                      <div className="sk-rect2 mr-1"></div>
                      <div className="sk-rect3 mr-1"></div>
                      <div className="sk-rect4 mr-1"></div>
                      <div className="sk-rect5"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Parcours;
